var App = App || {};

App.Separators = (function ($) {
    "use strict";

    var blogpostTags = $(".blog-post-primary-content .blog-post-primary-content-tags > ul").children("li");
    var blogpostCategories = $(".blog-post-masthead .blog-post-masthead-categories > ul").children("li");

    function init() {
        var separatedElements = [];
        if (blogpostTags.length) {
            separatedElements.push(blogpostTags);
        }
        if (blogpostCategories.length) {
            separatedElements.push(blogpostCategories);
        }

        adjustSeparatorsInGroup(separatedElements);

        $(window).resize(function () {
            adjustSeparatorsInGroup(separatedElements);
        }) 
    }

    function adjustSeparatorsInGroup(elementGroup) {
        if (elementGroup.length) {
            for (var i = 0; i < elementGroup.length; i++) {
                adjustSeparators(elementGroup[i])
            }
        }
    }

    function adjustSeparators(elements) {
        elements.removeClass("unseparated");
        if (elements.length) {
            var currentLineTop = 0,
                currentItemTop;
            var prevItem = null;

            elements.each(function () {
                currentItemTop = $(this).offset().top;
                if (currentItemTop != currentLineTop) { //at the start of a new line
                    currentLineTop = currentItemTop;
                    if (prevItem != null) {
                        prevItem.addClass("unseparated"); //remove separator pipe from previous item
                    }
                }
                prevItem = $(this);
            });
        }
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.Separators.init();
});